export class SystemParameters {
    constructor({
          id= null, 
          code= ``, 
          value= ``, 
          active= ``,
          group= ``, 
          dataType= ``,
          description= ``
      } = {}) {
      this.id = id;
      this.code = code;
      this.value = value;
      this.active = active;
      this.group = group;
      this.dataType = dataType;
      this.description = description;
    }
  }
  export function newEntity() {
    return new SystemParameters();
  }
  export function gridFields() {
    return Object.freeze([
        {
          key: 'code',
          label: 'lbl.basic.code',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'description',
          label: 'lbl.basic.description',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'group',
          label: 'lbl.basic.group',
          sortable: true,
          form: {
            type: 'select',
            options: [
              { value: null, text: '' },
              { value: 'S', text: 'System' },
              { value: 'E', text: 'End point' },
              { value: 'F', text: 'Funtional' },
              { value: 'Y', text: 'Synchronous' },
              { value: 'A', text: 'Asynchronous' }
            ]
          },
          formatter: function(val){
            switch (val) {
              case 'S':
                return "System"
              case 'E':
                return "End point"
              case 'F':
                return "Funtional"
              case 'Y':
                return "Synchronous"
                case 'A':
                return "Asynchronous"
              default:
                return "-";
            }
          }
        },
        {
          key: 'dataType',
          label: 'lbl.systemParameters.dataType',
          sortable: true,
          form: {
            type: 'select',
            options: [
              { value: null, text: '' },
              { value: 'T', text: 'Text' },
              { value: 'D', text: 'Date' },
              { value: 'N', text: 'Number' },
              { value: 'J', text: 'JSON' },
              { value: 'X', text: 'XML' },
              { value: 'U', text: 'URL' },
              { value: 'B', text: 'Boolean' }
            ]
          },
          formatter: function(val){
            switch (val) {
              case 'T':
                return "Text"
              case 'D':
                return "Date"
              case 'N':
                return "Number"
              case 'J':
                return "JSON"
              case 'X':
                return "XML"
              case 'U':
                return "URL"
              case 'B':
                return "Boolean"
              default:
                return "-";
            }
          }
        },
        {
          key: 'value',
          label: 'lbl.basic.value',
          form: {
            type: 'input'
          }
        },
        {
          key: 'active',
          label: 'lbl.basic.active',
          sortable: true,
          form: {
            type: 'boolean'
          }
        }        
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SystemParameters()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.groupFilter',
    'filter.dataTypeFilter',
    'filter.codeFilter',
    'filter.valueFilter',
    'filter.activeFilter'
  ];
  export const filter = {
    'groupFilter': "",
    'dataTypeFilter': "",
    'codeFilter': "",
    'valueFilter': "",
    'activeFilter': ""
  };